var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileOrdering = function SvgMobileOrdering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-ordering-icon-group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-ordering-icon-wrapper",
    transform: "translate(-229.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(69.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-mobile-order",
    transform: "translate(160.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Order",
    transform: "translate(5.370000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    x: -1.65966186e-15,
    y: 0,
    width: 13.2578102,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.441459854,
    y: 0.408759124,
    width: 12.3748905,
    height: 21.7880292,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "mobile-ordering-oval",
    stroke: "#1A1818",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 6.62890511,
    cy: 10.2189781,
    r: 4.66218978
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1A1818",
    fillRule: "nonzero",
    x: 4.52437956,
    y: 11.5924088,
    width: 1,
    height: 2.94306569
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1A1818",
    fillRule: "nonzero",
    x: 8.20788321,
    y: 11.5924088,
    width: 1,
    height: 2.94306569
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "mobile-ordering-oval",
    fill: "#1A1818",
    fillRule: "nonzero",
    cx: 4.80934307,
    cy: 10.3708029,
    rx: 1.47854015,
    ry: 2.12321168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29313869,12.0665693 C3.8259854,11.7886131 3.51065693,11.1322628 3.51065693,10.3708029 C3.50895816,10.0508277 3.56924068,9.73355129 3.68817518,9.43649635 C3.53635036,11.3564964 4.45664234,12.16 4.29313869,12.0665693 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.48437956,
    y1: 23.0446715,
    x2: 7.77343066,
    y2: 23.0446715,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6420438,8.24525547 L9.3010219,8.24525547 L9.3010219,11.4289051 C9.30165667,11.4460321 9.29529356,11.4626798 9.28339695,11.475017 C9.27150034,11.4873543 9.25509494,11.4943183 9.2379562,11.4943066 L9.06978102,11.4943066 C9.05264228,11.4943183 9.03623688,11.4873543 9.02434027,11.475017 C9.01244366,11.4626798 9.00608056,11.4460321 9.00671533,11.4289051 L9.00671533,8.24525547 L8.64233577,8.24525547 L8.64233577,11.4289051 C8.64299838,11.4464454 8.63632091,11.4634683 8.6239092,11.47588 C8.6114975,11.4882917 8.5944746,11.4949692 8.57693431,11.4943066 L8.41109489,11.4943066 C8.37497466,11.4943066 8.34569343,11.4650253 8.34569343,11.4289051 L8.34569343,8.24525547 L7.98131387,8.24525547 L7.98131387,11.4289051 C7.98194864,11.4460321 7.97558554,11.4626798 7.96368893,11.475017 C7.95179232,11.4873543 7.93538691,11.4943183 7.91824818,11.4943066 L7.75007299,11.4943066 C7.73293426,11.4943183 7.71652885,11.4873543 7.70463224,11.475017 C7.69273563,11.4626798 7.68637253,11.4460321 7.6870073,11.4289051 L7.6870073,8.24525547 L7.3459854,8.24525547 L7.17781022,11.6531387 C7.15445255,12.120292 7.58189781,12.4940146 8.11211679,12.4940146 L8.86189781,12.4940146 C9.39912409,12.4940146 9.82656934,12.1109489 9.79620438,11.6531387 L9.6420438,8.24525547 Z",
    id: "Path",
    fill: "#1A1818",
    fillRule: "nonzero"
  }))))))));
};
export default SvgMobileOrdering;